export default __webpack_public_path__ + "static/media/smvs_logo.196b9e26.png";